import data from "../data/php.json";

const phpQuiz = data.php;


export {phpQuiz};
